module.exports = __webpack_public_path__ + "static/media/Artboard12.1a1e86c8.png";